(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["swiss-customs-cart-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('swiss-customs-check')) {
    customElements.define(
      'swiss-customs-check',
      class SwissCustomsCheck extends HTMLElement {
        connectedCallback() {
          const input = this.querySelector('input');
          if (!input) return;
          input.addEventListener('change', () => {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({
                attributes: {swiss_customs_accepted: input.checked ? 'true' : 'false'},
              }),
            });
          });
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
